import React from 'react';
import { FadeUp } from './ui/FadeUp';
export function ServiceModelSection() {
  const tiers = [{
    title: 'HR & Admin Desk',
    description: 'Day-to-day HR support, employee questions, and issue resolution handled for you.',
    highlighted: false
  }, {
    title: 'People Operations Department',
    description: 'We set up your HR systems and stay involved so things actually run smoothly.',
    highlighted: true,
    badge: 'Most Popular'
  }, {
    title: 'People & Admin Operations',
    description: 'Full back-office support across HR and admin operations for growing teams.',
    highlighted: false
  }];
  return <section id="services" className="py-28 bg-white" data-id="element-349">
      <div className="max-w-[1240px] mx-auto px-8" data-id="element-350">
        <FadeUp className="text-center max-w-2xl mx-auto mb-16" data-id="element-351">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-352">
            HR support that grows with your team
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed" data-id="element-353">
            Start with day-to-day support or scale into a full HR function.
          </p>
        </FadeUp>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch mb-16" data-id="element-354">
          {tiers.map((tier, index) => <FadeUp key={index} delay={index * 0.1} className="h-full" data-id="element-355">
              <div className={`relative h-full bg-white rounded-xl p-8 flex flex-col transition-all duration-300 ${tier.highlighted ? 'border-2 border-purple-300 shadow-[0_10px_40px_rgba(0,0,0,0.08)]' : 'border border-[#eee] shadow-[0_10px_30px_rgba(0,0,0,0.05)]'}`} data-id="element-356">
                {tier.badge && <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-gradient-primary text-white text-xs font-bold rounded-full uppercase tracking-wider" data-id="element-357">
                    {tier.badge}
                  </div>}
                <h3 className="text-xl font-bold text-gray-900 mb-4 mt-2" data-id="element-358">
                  {tier.title}
                </h3>
                <p className="text-gray-600 leading-relaxed flex-grow" data-id="element-359">
                  {tier.description}
                </p>
              </div>
            </FadeUp>)}
        </div>

        <FadeUp delay={0.4} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-360">
          <a href="https://calendly.com/krystina-joinsparkhr/30min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-white bg-gradient-primary rounded-full hover:shadow-md hover:opacity-90 transition-all w-full sm:w-auto" data-id="element-361">
            Schedule a Call
          </a>
          <a href="#start-here" className="inline-flex items-center justify-center px-8 py-4 text-base font-medium text-gray-700 bg-gray-50 rounded-full hover:bg-gray-100 transition-colors w-full sm:w-auto" data-id="element-362">
            Not sure? Start here
          </a>
        </FadeUp>
      </div>
    </section>;
}